import {
  EVENT_CATEGORY_CLASS_TODO,
  EVENT_CATEGORY_CONTENT,
  EVENT_ACTION_DOWNLOAD,
  EVENT_TARGET_DOCUMENT_PAGES,
  EVENT_TARGET_TYPE_DOCUMENT_TYPE,
  EVENT_TARGET_DOCUMENT_FILTERED_PAGES,
  EVENT_ACTION_OPEN,
} from 'approot/shared/data-tracker/data-events.constants';
import { LessonType } from 'webclient.constants';

export const generateWorksheetDataAttributes = (
  lesson: {
    id: number;
    type: LessonType;
  },
  dataEvent: string,
  pageNumber: number,
  pagesNumbers: number[],
  displaySingleSheet?: boolean
) => {
  const dataEventLabel = {
    target_type: lesson.type,
    target_identifier: `${lesson.id}`,
    [EVENT_TARGET_TYPE_DOCUMENT_TYPE]: dataEvent,
  };
  return {
    dataEvent: EVENT_CATEGORY_CONTENT,
    dataEventAction: EVENT_ACTION_DOWNLOAD,
    dataEventLabel: {
      ...dataEventLabel,
      [EVENT_TARGET_DOCUMENT_PAGES]: pagesNumbers,
      [EVENT_TARGET_DOCUMENT_FILTERED_PAGES]: false,
    },
    bookmarkDataEvent: EVENT_CATEGORY_CLASS_TODO,
    bookmarkDataEventAction: EVENT_ACTION_OPEN,
    bookmarkDataEventLabel: {
      target_type: lesson.type,
      target_identifier: `${lesson.id}`,
      assign_button_location: 'card',
    },
  };
};
